import isArray from 'lodash/isArray'
import isNull from 'lodash/isNull'
import isString from 'lodash/isString'
import moment from 'moment'

import {
	AppDateFormats,
	AppDateWithTimeFormats,
	DEFAULT_SYSTEM_FORMAT_DAY_PICKER,
	DEFAULT_SYSTEM_FORMAT_DAY_WITH_TIME
} from 'Core/constants'

type filterData = string | null

export const getFormatDate = (date: string | Date, format: string) =>
	moment(new Date(date)).format(format)

export const convertDateFromStringToMoment = (
	stringDate?: filterData,
	format: string = DEFAULT_SYSTEM_FORMAT_DAY_PICKER
): moment.Moment | null => {
	if (isString(stringDate)) {
		return moment(stringDate, format)
	}
	return null
}

export const convertDateFromMomentToString = (
	momentDate: moment.Moment | null,
	format: string = DEFAULT_SYSTEM_FORMAT_DAY_PICKER
): string | null => {
	if (!momentDate) {
		return null
	}

	return momentDate.format(format)
}

export const convertStringDateFormat = (value: string | null, format: AppDateFormats) =>
	value ? moment(value).format(format) : ''

export const isSameDate = (opositeDate: moment.Moment, current: moment.Moment) =>
	opositeDate.format(DEFAULT_SYSTEM_FORMAT_DAY_PICKER).valueOf() ===
	current.format(DEFAULT_SYSTEM_FORMAT_DAY_PICKER).valueOf()

export const dateSort = (
	dateA: string | null,
	dateB: string | null,
	format: string = DEFAULT_SYSTEM_FORMAT_DAY_PICKER
) => {
	if (isNull(dateA) && isNull(dateB)) {
		return 0
	} else if (isNull(dateA)) {
		return -1
	} else if (isNull(dateB)) {
		return 1
	}
	return moment(dateA, format).diff(moment(dateB, format))
}

export const getCorrectFilterDate = (
	date: string | number | boolean | string[] | null | undefined
) => (isArray(date) ? (date[0] as string) : (date as BasicString))

export const convertStringToCorrectFormat = (
	value: BasicString,
	format: string = DEFAULT_SYSTEM_FORMAT_DAY_PICKER
) => (value ? moment(value).format(format) : null)

export const validateOverlapRanges = ({
	startDate,
	endDate,
	ranges
}: {
	startDate: moment.Moment | null
	endDate: moment.Moment | null
	ranges: { min: moment.Moment; max: moment.Moment }[]
}): boolean => {
	if (startDate && endDate) {
		return !ranges.some(({ min, max }) => {
			if (!min || !max) {
				return false
			}
			const isCurrentRangeInExist =
				startDate?.isBetween(min, max, 'day', '[]') ||
				endDate?.isBetween(min, max, 'day', '[]')

			const isExistRangeInCurren =
				min?.isBetween(startDate, endDate, 'day', '[]') ||
				max?.isBetween(startDate, endDate, 'day', '[]')
			return isCurrentRangeInExist || isExistRangeInCurren
		})
	}
	return true
}

export const convertStringToDateTimeFormat = (
	dateTime: BasicString,
	dateFormat: AppDateFormats,
	isSeconds: boolean = true
): BasicString => {
	if (!dateTime) {
		return null
	}

	const [date, time] = dateTime.split(' ')
	const formatDate = convertStringDateFormat(date, dateFormat)

	const [hours, minutes, seconds] = time.split(':')
	const parsedHours = parseInt(hours)
	const partOfDay = parsedHours < 12 ? 'AM' : 'PM'
	const correctHours = parsedHours % 12 || 12
	return `${formatDate} ${correctHours}:${minutes}${isSeconds ? `:${seconds}` : ''} ${partOfDay}`
}

export const convertDateToEdtDate = (
	dateTime: BasicString,
	dateFormat: AppDateWithTimeFormats,
	shouldFormatFromUts: boolean = true
): BasicString => {
	if (!dateTime) {
		return null
	}
	const hoursBetweenCurrentTimeAndEdt = shouldFormatFromUts ? 4 : 0
	const edtDate = moment(dateTime, DEFAULT_SYSTEM_FORMAT_DAY_WITH_TIME)
		.subtract(hoursBetweenCurrentTimeAndEdt, 'hours')
		.format(dateFormat)
	return `${edtDate} EDT`
}

export const convertStringToMoment = (value: string | Nullish, format: AppDateFormats) =>
	value ? moment(value).format(format) : null

export const convertStringToPureMoment = (value: string | Nullish) => (value ? moment(value) : null)
